import JSEncrypt from 'jsencrypt'
import {removeDataInLocalStorage, saveDataToLocalStorage} from "./localStorage";

export const pwdPubPrefix='---BEGIN---ADD---Prefix---MIGfMA0GCSq'
export async function addJsEncrypt(passWord) {
    var encryptor = new JSEncrypt()  // 创建加密对象实例
    let pubKey = await (await fetch('http://www.user.biozeron.com/person_api/sp/common/security/rsa/public-key', {
        method: 'get',
    })).text()
    encryptor.setPublicKey(pubKey)//设置公钥
    var rsaPassWord = encryptor.encrypt(passWord)  // 对内容进行加密
    return addPubPrefix(rsaPassWord)
}

function addPubPrefix(rsaPassWord) {
    rsaPassWord = pwdPubPrefix + rsaPassWord
    return rsaPassWord
}
export async function saveUserAccount(userInfo,isRememberAccountPwd,localName='account') {
    let loginForm ={...userInfo}
    if (!userInfo.password.startsWith(pwdPubPrefix)) {
        loginForm.password = await addJsEncrypt(loginForm.password)
    }
    if (isRememberAccountPwd) {
        loginForm.remeber =isRememberAccountPwd
        saveDataToLocalStorage(localName, JSON.stringify(loginForm))
    } else {
        removeDataInLocalStorage(localName)
    }
    loginForm.password = loginForm.password.slice(pwdPubPrefix.length)
    return loginForm

}
